import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Box,
  IconButton,
} from '@mui/material'
import { useEffect, useState } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import SmsIcon from '@mui/icons-material/Sms'
import { PatientDto } from '@/services/api'

interface StripePaymentDialogProps {
  open: boolean
  onClose: () => void
  billId: number
  patient: Partial<PatientDto> | null
}

export default function StripePaymentDialog({
  open,
  onClose,
  billId,
  patient,
}: StripePaymentDialogProps) {
  const [phoneNumber, setPhoneNumber] = useState(patient?.phoneNumber || '')

  const paymentLink = `https://ether-healthcare.stripe.com/pay/${billId}`

  const handleCopyLink = () => {
    navigator.clipboard.writeText(paymentLink)
  }

  const handleSendSms = () => {
    console.log(
      `Sending SMS to ${phoneNumber} with payment link: ${paymentLink}`,
    )
  }

  useEffect(() => {
    if (patient?.phoneNumber) {
      setPhoneNumber(patient.phoneNumber)
    }
  }, [patient])

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Lien de paiement Stripe</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Lien de paiement pour la facture #{billId}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField
              value={paymentLink}
              variant="outlined"
              size="small"
              fullWidth
              InputProps={{
                readOnly: true,
              }}
            />
            <IconButton onClick={handleCopyLink} color="primary">
              <ContentCopyIcon />
            </IconButton>
          </Box>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Envoyer par SMS
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TextField
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Numéro de téléphone"
              variant="outlined"
              size="small"
              fullWidth
            />
            <Button
              variant="contained"
              startIcon={<SmsIcon />}
              onClick={handleSendSms}
              disabled={!phoneNumber.trim()}
            >
              Envoyer
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fermer</Button>
      </DialogActions>
    </Dialog>
  )
}
